import api, { API_BASE, defaultOpt } from "./apiService";
import { filterTable, findTableRow, rowTransform } from "./tableUtils";
import { dateYYYYMMMDD } from "./commonParse";

export async function getAllGlues() {
  return (await api.get(`${API_BASE}/list-glues`, {})).data;
}

export async function addGlue(form) {
  return (await api.post(`${API_BASE}/add-glue`, form, defaultOpt())).data;
}

export async function deleteGlue(id) {
  return (await api.delete(`${API_BASE}/delete-glue/${id}`, defaultOpt())).data;
}

export async function updateGlue(id, form) {
  return (await api.post(`${API_BASE}/edit-glue/${id}`, form, defaultOpt()))
    .data;
}

function stationDest(glue) {
  return `Station-${glue.station === 1 ? "A" : "B"} (${glue.id}: ${dateYYYYMMMDD(glue.epoxy_expiry_date)})`;
}

export function makeGlueOptions(
  glueList,
  hideExhaust = false,
  showOnlyLocal = true,
) {
  let options = filterTable(
    glueList,
    (glue) =>
      (hideExhaust ? glue.in_stock : true) &&
      (showOnlyLocal ? glue.source !== "CERN" && glue.source !== "SC" : true),
  );
  return rowTransform(options, (glue) => ({
    value: glue.id,
    label: glueDescription(glueList, glue.id),
    available: glue.in_stock,
  }));
}

export function makeRemoteGlueOptions(glueList) {
  let options = filterTable(
    glueList,
    (glue) => glue.source === "CERN" || glue.source === "SC",
  );
  return rowTransform(options, (glue) => ({
    value: glue.id,
    label: glueDescription(glueList, glue.id),
    available: glue.in_stock,
  }));
}

export function glueDescription(glueList, id) {
  const glue = findTableRow(glueList, (g) => Number(g.id) === Number(id));
  return glue
    ? glue.station === 0
      ? glueSourceDisplay(glue.source)
      : stationDest(glue)
    : "--";
}

export const stationOptions = [
  { value: 1, label: "Station A" },
  { value: 2, label: "Station B" },
];

const __s_map__ = {
  HM: "Huntsman",
  BMC: "Bode Moller Chemical",
  CERN: "CERN PCB Lab (REMOTE)",
  SC: "ShenZhen Capel (REMOTE)",
};

export function glueSourceDisplay(s) {
  return s in __s_map__ ? `[${s}] ${__s_map__[s]}` : "UNKNOWN";
}

export const glueSourceOptions = Object.keys(__s_map__).map((k) => ({
  value: k,
  label: __s_map__[k],
}));
